import Popup from './src/popup'

export default Popup
